import React, { Fragment } from 'react';
import styles from './About.module.scss';

const lines1 = [
  `Diamour is the brainchild of Shivani Doshi. A bespoke range of artistic jewellery, it is inspired by nature’s raw beauty.
  We imbibe splendid gemstones amidst geometrical shapes and contemporary silhouettes. Both precious and semi-precious,
  these jewels are handpicked during Shivani’s global adventures.`,

  `Empowering the wearer and beguiling onlookers, our pieces are extremely thought provoking. Lovingly designed, they come
  alive by blending technology with age-old handcrafting wisdom. It’s a splendid fraternization of contradictions: bold,
  yet effeminate, quirky, yet heirloom worthy.`,

  `Diamour happily creates personalized pieces for you, whatever be the occasion.`
];

const lines2 = [
  `Shivani’s attraction for eccentric jewellery began as a little girl. With a family business of diamonds,
  she was always surrounded by the glittering world of jewels. Forbidden to touch the real thing, she would weave beads into pretty ornaments.
  Trotting about in self-made jewellery, the 10 year old would feel like a princess.`,
  
  `Couple of years, an art degree and jewellery-designing course later, turning her hobby into a business was inevitable.
  Being an avid traveller and art connoisseur helped actuate this dream. She drives inspiration from her surroundings,
  making all kinds of gems match the rhythm of her thoughts. Having a keen eye for turning treasures into abstract art,
  she creates unique jewellery, loved by all.`
];

const About = props => {
  return (
    <Fragment>
      <h1>About Us – Diamour</h1>
      {lines1.map((line, key) => (
        <p className={styles.aboutLine} key={key}>{line}</p>
      ))}
      <h1>The Woman Behind Diamour  – Shivani Doshi</h1>
      {lines2.map((line, key) => (
        <p className={styles.aboutLine} key={key}>{line}</p>
      ))}
    </Fragment>
  );
};

export default About;
